import { render, staticRenderFns } from "./ProductDialogue.vue?vue&type=template&id=30b7c536&"
import script from "./ProductDialogue.vue?vue&type=script&lang=ts&"
export * from "./ProductDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports